<script>
  import ProfileImg from '../components/ProfileImage.svelte';
  import FormInput from '../components/FormControls/FormInput.svelte';
  import Select from 'svelte-select';
  import { masterData, getMasterData } from '../stores/masterData.js';
  import { client } from 'root/api/index.js';
  import { onDestroy, onMount } from 'svelte';
  import * as yup from 'yup';
  import { createForm } from 'svelte-forms-lib';
  import { getUserInfo } from '../stores/auth';
  import { navigate } from 'svelte-routing';
  import {
    itemIndexOf,
    searchKeyByValue,
    customInputEvent,
    setYupMessage,
    configItem,
    cloneArray,
  } from 'components/Helper.js';
  import Loader from '../components/Loader.svelte';
  import SimpleFileUploader from '../components/SimpleFileUploader.svelte';
  import { getContext } from 'svelte';
  import DropDown from '../components/DropDown.svelte';

  import { element } from 'svelte/internal';
  const showDialog = getContext('showDialog');
  export let id = 0;
  let selectedRoleId = null;
  let selectedDateFormatId = null;
  let selectedTimeZoneId = null;
  let selectedUnitId = null;
  let selectedDeliveryVerticalsId = null;
  let selectedUsers = null;
  let deliveryVerticals = [];
  let isFormPending = false;
  let serverErrors = [];
  let role = [];
  let timeZones = [];
  let dateFormates = [];
  let units = [];
  let unitUsers = [];
  let selectedUnits = [];
  let selectedDeliveryVerticals = [];
  let userRoles = {};
  let otherdeliveryVertical = '';
  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  let photoUrl =
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8FuEJbKwDdaz1h387130xmYkAIQbZpahhbQ&usqp=CAU';
  var mobileObj = { mobile: '' };
  var fileObj = {
    fileId: 0,
    fileName: '',
    filePath: '',
    origionalName: '',
  };
  let defaultValue = {
    id: '',
    title: '',
    countryId: '',
    countryId: '',
    state: '',
    stateId: '',
    stateLabel: undefined,
    countryLabel: undefined,
    state: '',
    firstName: '',
    slackUsername: '',
    msTeamUsername: '',
    photoUrl: '',
    lastName: '',
    email: '',
    roleId: '',
    password: '',
    confirmPassword: '',
    deactivateDate: '',
    units: undefined,
    file: fileObj,
    users: undefined,
    dateFormatId: configItem.defaultFormatId,
    deliveryVerticalIds: [],
    deliveryVerticalLabel: [],
    legacyCompanyType: '',
    associatedRegionId: '',
    associatedRegionLabel: undefined,
    timeZoneId: undefined,
    notificationTypes: [],
    mobileNos: [mobileObj],
  };
  setYupMessage(yup);
  const { form, errors, handleChange, handleSubmit } = createForm({
    initialValues: { ...defaultValue },
    validationSchema: yup.object().shape({
      slackUsername: yup.string().nullable(),
      msTeamUsername: yup.string().nullable(),
      firstName: yup.string().required(),
      lastName: yup.string().required(),
      email: yup.string().email().required('Valid email is required'),
      roleId: yup.string().required(),
      title: yup.string().nullable(),
      countryId: yup.string().nullable(),
      stateId: yup.string().nullable(),
      state: yup.string().nullable(),
      // password: yup.string(),
      // ...(id == 0 && {
      //   password: yup.string().required(),
      // }),
      // confirmPassword: yup.string().when("password", {
      //   is: (value) => {
      //     return value.trim().length != 0;
      //   },
      //   then: yup
      //     .string()
      //     .oneOf([yup.ref("password"), null], "Passwords must match")
      //     .required(),
      // }),
      units: yup
        .array()
        .required()
        .min(1, 'Select unit')
        .of(
          yup.object().shape({
            unitId: yup.string(),
            name: yup.string(),
            accessStatus: yup.boolean(),
          }),
        ),
      file: yup.object().shape({
        fileId: yup.string(),
        fileName: yup.string(),
        filePath: yup.string(),
        origionalName: yup.string(),
      }),
      users: yup.array().when('roleId', {
        is: (value) => {
          return $form.roleId == '3';
        },
        then: yup
          .array()
          // .required()
          // .min(1, 'Select user')
          .of(
            yup.object().shape({
              id: yup.string(),
              userId: yup.number(),
              firstName: yup.string(),
              lastName: yup.string(),
            }),
          ),
        otherwise: yup.array().of(
          yup.object().shape({
            id: yup.string(),
            userId: yup.number(),
            firstName: yup.string(),
            lastName: yup.string(),
          }),
        ),
      }),
      dateFormatId: yup.number().required(),
      deliveryVerticalIds: yup
        .array()
        .min(1, 'Select at least one Delivery Vertical')
        .max(5, "You can't select more than 5 items in Delivery Verticals")
        .required(),
      legacyCompanyType: yup.string().nullable(),
      associatedRegionId: yup.string().required(),
      timeZoneId: yup.number().required(),
      notificationTypes: yup.array().of(
        yup.object().shape({
          id: yup.string(),
          name: yup.string(),
          email: yup.number(),
          slack: yup.number(),
        }),
      ),
      mobileNos: yup.array().of(
        yup.object().shape({
          id: yup.string(),
          mobile: yup.string(),
        }),
      ),
    }),
    onSubmit: (values) => {
      let data = getFormData(values);

      isFormPending = true;
      client
        .userAdd(data)
        .then((response) => {
          isFormPending = false;
          navigate('/user', { replace: true });
        })
        .catch((err) => {
          isFormPending = false;
          serverErrors = [err.message];
          showDialog({ message: serverErrors });
        });
    },
  });
  const getFormData = (data) => {
    let values = { ...data };
    if (isManager == false) {
      values.users = [];
    } else {
      values.users = selectedUsers;
    }
    let subArr = [];
    values.mobileNos.map((item, index) => {
      if (item.mobile != '') {
        subArr.push(item);
      }
    });
    values.mobileNos = subArr;
    let subUnit = [];
    if (typeof values.units !== 'undefined' && values.units != null) {
      values.units.map((item, index) => {
        if (itemIndexOf(units, values.units[index].id, 'id') > -1) {
          item.clients = selectedUnitClient[item.id];
          item.users = selectedUnitUser[item.id];
          subUnit.push(item);
        }
      });
    }

    values.units = subUnit;
    return values;
  };

  const removeUnitUser = (unitId) => {
    let oldUsers = $form.users;
    for (var i = oldUsers.length - 1; i >= 0; i--) {
      if (oldUsers[i].unitId == unitId) {
        oldUsers.splice(i, 1);
      }
    }
    $form.users = oldUsers;
  };

  const removeUnit = (unitId) => {
    let oldUnits = $form.units;
    let i = searchKeyByValue(oldUnits, 'id', unitId);
    oldUnits.splice(i, 1);
    $form.units = oldUnits;
    removeUnitUser(unitId);
  };

  const checkTaskCount = (unitId, comeFrom) => {
    if ($form.id > 0) {
      client
        .getUserUnitTaskCount({ id: $form.id, unitId: unitId })
        .then((response) => {
          let taskCount = response.data.openTaskCount;
          //  if(taskCount >0)
          {
            let taskMessage = '';
            if (!(comeFrom != undefined && comeFrom == 'checkbox')) {
              taskMessage +=
                'Doing so will remove ' +
                $form.firstName +
                ' from all the clients and the manager teams with which ' +
                $form.firstName +
                ' is currently associated with';
              taskMessage += '<br/><br/>';
            }
            taskMessage +=
              "<div class='d-flex justify-content-center'>Current open tasks of this user: " +
              response.data.openTaskCount +
              " <a style='margin-left: 5px;' target='_blank' href='/redirect/task#action=openTask&userId=" +
              $form.id +
              '&unitId=' +
              unitId +
              "'>View Task</a></div>";
            taskMessage +=
              "<div class='d-flex justify-content-center'>Current scheduled task of this user: " +
              response.data.scheduleTaskCount +
              " <a style='margin-left: 5px;' target='_blank' href='/redirect/task#action=scheduleTask&userId=" +
              $form.id +
              '&unitId=' +
              unitId +
              "'>View Task</a></div>";
            // taskMessage+="<div class='d-flex justify-content-center'>Clients associated of this user: "+response.data.clientCount+"</div>";
            showDialog({
              type: 'confirm',
              isTopHeading: 'N',
              isHtmlMessage: true,
              title: 'Are you sure?',
              message: taskMessage,
              okFunc: () => {
                if (comeFrom == undefined) {
                  removeUnit(unitId);
                }
              },
              cancelFunc: () => {
                if (comeFrom != undefined && comeFrom == 'checkbox') {
                  let oldUnits = $form.units;
                  let i = searchKeyByValue(oldUnits, 'id', unitId);
                  oldUnits[i].active = 1;
                  $form.units = oldUnits;
                }
              },
            });
          }
        })
        .catch((err) => {
          showDialog({ message: [err.message] });
        });
    } else {
      removeUnit(unitId);
    }
  };

  const setDropDown = () => {
    roleDefine();
    if ($form.roleId > 0 && role.length > 0) {
      selectedRoleId = {
        id: $form.roleId,
        name: role[searchKeyByValue(role, 'id', $form.roleId)].name,
      };
    }
    if ($form.timeZoneId > 0 && timeZones.length > 0) {
      selectedTimeZoneId = {
        id: $form.timeZoneId,
        name: timeZones[searchKeyByValue(timeZones, 'id', $form.timeZoneId)].name,
      };
    }
    if ($form.dateFormatId > 0 && dateFormates.length > 0) {
      selectedDateFormatId = {
        id: $form.dateFormatId,
        name: dateFormates[searchKeyByValue(dateFormates, 'id', $form.dateFormatId)].name,
      };
    }

    if ($form.countryId > 0) {
      $form.countryLabel = countries[searchKeyByValue(countries, 'id', $form.countryId)];
    }
    if ($form.associatedRegionId > 0) {
      $form.associatedRegionLabel =
        associatedRegions[searchKeyByValue(associatedRegions, 'id', $form.associatedRegionId)];
    }
    if ($form.stateId > 0) {
      $form.stateLabel = states[searchKeyByValue(states, 'id', $form.stateId)];
    }
    if ($form.deliveryVerticalIds.length > 0) {
      selectedDeliveryVerticalsId = $form.deliveryVerticalIds;
      selectedDeliveryVerticals = [];
      let arr = [];
      selectedDeliveryVerticalsId.forEach((element) => {
        // selectedDeliveryVerticals.push(element)
        arr.push(deliveryVerticals[searchKeyByValue(deliveryVerticals, 'id', element)]);
        selectedDeliveryVerticals = arr;
      });
      $form.deliveryVerticalLabel = arr;
      // $form.deliveryVerticalIds=selectedDeliveryVerticals
    }
  };
  //let disablePassword=true;
  let mountLoaded = false;
  let masterLoaded = false;
  const loadData = () => {
    if (mountLoaded && masterLoaded && id > 0) {
      getUserDetail();
    }
  };
  onMount(() => {
    mountLoaded = true;
    loadData();
    // deliveryVerticals = getMasterData().deliveryVerticals;
    // setTimeout(()=>{
    //   disablePassword=false
    // },1000)
  });
  const roleDefine = () => {
    if (userRoles.manager == userRoleId) {
      role = role.filter((ai) => ai.id == userRoles.user);
    } else if (userRoles.unit_admin == userRoleId || userRoles.admin == userRoleId) {
      role = role.filter((ai) => ai.id != userRoles.admin);
    }
  };

  const addMobile = () => {
    let mobileNos = $form.mobileNos;
    mobileNos.push({ ...mobileObj });
    $form.mobileNos = mobileNos;
  };
  const removeMobile = (i) => {
    let mobileNos = $form.mobileNos;
    // if (mobileNos[i].id != undefined && mobileNos[i].id > 0) {
    //   mobileNos[i].deleted = 1;
    // } else {
    mobileNos.splice(i, 1);
    // }
    $form.mobileNos = mobileNos;
  };

  const userRoleId = getUserInfo().roleId;
  let isManager = false;

  let unitClients = [];
  const getUnitUsers = () => {
    if (selectedUnits.length == 0 && typeof $form.users !== 'undefined') {
      $form.users.length = 0;
      selectedUsers = null;
      unitUsers = [];
      unitClients = [];
    }
    if (isManager && selectedUnits.length != 0) {
      client
        .unitUsers({
          units: selectedUnits,
          editUserId: $form.id,
          inactiveCondition: 1,
        })
        .then((response) => {
          let detail = response.data;
          unitUsers = detail.users;
          if (typeof selectedUsers !== 'undefined' && selectedUsers != null) {
            for (var index in selectedUsers) {
              if (itemIndexOf(unitUsers, selectedUsers[index].userId, 'userId') > -1) {
              } else {
                selectedUsers.splice(index, 1);
              }
            }
          }
        })
        .catch((err) => {
          showDialog({ message: err.message });
        });
    }
    if ($form.units) {
      client
        .unitClients({
          units: $form.units
            .filter((item) => {
              return item.accessStatus == true;
            })
            .map((item) => {
              item.unitId = item.id;
              return item;
            }),
        })
        .then((response) => {
          unitClients = response.data.clients;
        });
    }
  };
  let oldPhotoUrl;
  let ajaxLoading = id > 0;
  const getUserDetail = () => {
    $form = { ...defaultValue };
    selectedRoleId = null;
    selectedDateFormatId = null;
    selectedTimeZoneId = null;
    selectedUnitClient = {};
    selectedUnitUser = {};
    serverErrors = [];
    client
      .userDetail({ id: id })
      .then((response) => {
        if (response.data.mobileNos.length <= 0) {
          response.data.mobileNos.push({ ...mobileObj });
        }

        response.data.units.map((item) => {
          selectedUnitClient[item.id] = item.clients;
          selectedUnitUser[item.id] = item.users;
        });

        oldPhotoUrl = response.data.photoUrlPath;

        $form = response.data;
        $form.file = fileObj;
        $form.password = '';
        $form.confirmPassword = '';
        selectedUsers = response.data.users;
        selectedUnitId = response.data.units;
        selectedUnits = [];
        selectedUnitId.forEach((element) => {
          if (id == 0 || element.accessStatus) {
            selectedUnits.push({ unitId: element.id });
          }
        });
        $form.deliveryVerticalLabel = [];
        setDropDown();
        isManagerSelect();
        getUnitUsers();
        ajaxLoading = false;
      })
      .catch((err) => {
        showDialog({ message: err.message });
      });
  };

  const isManagerSelect = () => {
    isManager = userRoles.manager == $form.roleId;
    if (isManager) {
      getUnitUsers();
    } else {
      if (selectedUsers != undefined && selectedUsers.length <= 0) {
        selectedUsers = undefined;
      }
    }
  };
  const onCancel = () => {
    navigate('/user', { replace: true });
  };
  let countries = [];
  let stateCountryId = 0;
  let states = [];
  let associatedRegions = [];
  let legacyCompanyTypeLabel = [];
  let legacyCompanyTypes = [];
  const unsubscribe = masterData.subscribe((state) => {
    client.checkAuth().then(() => {
      if (state != undefined) {
        countries = state.countries;
        states = state.states;
        stateCountryId = state.stateCountryId;
        role = getMasterData().roles;
        deliveryVerticals = getMasterData().deliveryVerticals;
        associatedRegions = getMasterData().associatedRegions;
        legacyCompanyTypeLabel = getMasterData().legacyCompanyTypeLabel;
        // legacyCompanyTypes = [...getMasterData().legacyCompanyType];
        timeZones = getMasterData().timeZones;
        dateFormates = cloneArray(getMasterData().dateFormates).map((item) => {
          if (id == 0 && item.id == configItem.defaultFormatId) {
            item.name += ' (Default)';
          }
          return item;
        });
        units = getMasterData().units.map((item) => {
          item.accessStatus = true;
          return item;
        });
        userRoles = getMasterData().userRoleId;
        setDropDown();

        if (userRoles.manager == userRoleId) {
          window.location = '/invalid-access';
        }
        masterLoaded = true;
        loadData();
      }
    });
  });

  function addDeliveryVerticalType() {
    let selectSows = deliveryVerticals.filter((item) => item.checked);
    if (selectSows.length > 0) {
      let arr = $form.deliveryVerticalLabel;
      for (let i in selectSows) {
        let selectSow = selectSows[i];
        if (searchKeyByValue(arr, 'id', selectSow.id) !== -1) {
          return showDialog({
            message: 'Delivery Vertical already selected',
          });
        }
      }
      let selectedId = [];
      for (let i in selectSows) {
        let selectSow = selectSows[i];
        arr.push({
          id: selectSow.id,
          name: selectSow.name,
        });
        // selectedId.push(selectSow.id)
        $form.deliveryVerticalLabel = arr;
      }
      $form.deliveryVerticalLabel.forEach((value) => {
        selectedId.push(value.id);
      });
      $form.deliveryVerticalIds = selectedId;
      handleChange(customInputEvent(`deliveryVerticalIds`, selectedId));
      setTimeout(() => {
        deliveryVerticals = deliveryVerticals.map((item) => {
          item.checked = false;
          return item;
        });
      }, 100);
    } else {
      showDialog({ message: 'Please Select Delivery Vertical' });
    }
  }

  const deSelectDeliveryVertical = () => {
    deliveryVerticals = deliveryVerticals.map((item) => {
      item.checked = false;
      return item;
    });
  };
  const removeType = (key, type) => {
    let arr = $form.deliveryVerticalLabel;
    arr.splice(key, 1);
    $form.deliveryVerticalLabel = arr;
    let selectedId = [];
    for (let i in arr) {
      let selectSow = arr[i];
      selectedId.push(selectSow.id);
    }
    $form.deliveryVerticalIds = selectedId;
    handleChange(customInputEvent(`deliveryVerticalIds`, selectedId));
  };

  onDestroy(() => {
    unsubscribe();
    deSelectDeliveryVertical();
  });

  let selectedUnitClient = {};
  let selectedUnitUser = {};

  let selectedUnitLabel;
  let selectedUnitUserLabel = {};
  let objState;
</script>

<div class="d-flex h-100 w-100 p-3 flex-column container">
  <div class="block-header mb-2">
    <div class="row align-items-center">
      <div class="col">
        <h2 class="page-title">
          {#if id == 0}
            Add User
          {:else}
            Edit User
          {/if}
        </h2>
      </div>
    </div>
  </div>
  <div class="page-content card-content bg-white mb-3">
    <div class="d-flex flex-column h-100">
      <div class="page-content">
        <div class="d-flex flex-row h-100">
          <div class="user-profile-img-block d-flex flex-column">
            <div
              class="profile-image mb-3 mt-5 mx-auto position-relative profile-edit-block"
              style="min-width:120px;"
            >
              {#if ajaxLoading == false}
                <SimpleFileUploader
                  on:fileChanged={(event) => {
                    if (event.detail.type == 'add') {
                      $form.photoUrl = event.detail.fileName;
                    } else if (event.detail.type == 'delete') {
                      $form.photoUrl = '';
                    } else if (event.detail.type == 'uploading') {
                      isFormPending = true;
                    } else if (event.detail.type == 'uploaded') {
                      isFormPending = false;
                    }
                  }}
                  photoUrl={oldPhotoUrl}
                  requestFrom="add-user"
                  entityId={$form.id}
                />
              {/if}
            </div>
          </div>
          <div class="profile-content w-100 h-100 p-3">
            {#if $form.deactivateDate != ''}
              <div class="row">
                <div class="col-md-12 justify-content-end align-items-end d-flex">
                  <div
                    class="form-group mb-0 text-left deactive-user d-flex flex-row align-items-center"
                  >
                    <img
                      alt=""
                      class="icon-16 me-2"
                      src="/images/remove-user.svg"
                    />
                    <div>
                      <span class="color-blue font-weight-400 font-size-12 mb-3"
                        >Deactivated on:</span
                      >
                      {$form.deactivateDate}
                    </div>
                  </div>
                </div>
              </div>
            {/if}

            <div class="row mt-4">
              <div class="col-md-6">
                <FormInput
                  label="First Name "
                  type="text"
                  placeholder="Enter First Name"
                  handleChange={handleChange}
                  name="firstName"
                  error={$errors.firstName}
                  bind:value={$form.firstName}
                  autoFocus={true}
                />
              </div>
              <div class="col-md-6">
                <FormInput
                  label="Last Name "
                  type="text"
                  placeholder="Enter Last Name"
                  handleChange={handleChange}
                  name="lastName"
                  error={$errors.lastName}
                  bind:value={$form.lastName}
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <FormInput
                  label="Title"
                  type="text"
                  placeholder="Enter Designation"
                  handleChange={handleChange}
                  name="title"
                  error={$errors.title}
                  bind:value={$form.title}
                  autoFocus={true}
                />
              </div>
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <FormInput
                    label="Email"
                    type="email"
                    placeholder="Enter Email"
                    handleChange={handleChange}
                    name="email"
                    error={$errors.email}
                    bind:value={$form.email}
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div
                  class="form-group mb-3 select-block position-relative {$errors.roleId
                    ? 'error'
                    : ''}"
                >
                  <label
                    for=""
                    class="form-label">Role</label
                  >
                  <Select
                    class="form-control"
                    showChevron={true}
                    isClearable={true}
                    bind:selectedValue={selectedRoleId}
                    placeholder="Select: Role"
                    containerClasses="form-control"
                    items={role}
                    getSelectionLabel={(option) => {
                      return option.name;
                    }}
                    name="roleId"
                    on:select={(ev) => {
                      if (
                        id > 0 &&
                        isManager &&
                        $form.users.length > 0 &&
                        userRoles.manager != ev.detail.id
                      ) {
                        showDialog({
                          type: 'confirm',
                          isTopHeading: 'N',
                          isHtmlMessage: true,
                          title: 'Are you sure?',
                          message:
                            "Changing manager's role to any other role would remove all the sub users under that manager.",
                          okFunc: () => {
                            $form.users = [];
                            $form.roleId = ev.detail.id;
                            handleChange(customInputEvent(`roleId`, ev.detail.id));
                            isManagerSelect();
                          },
                          cancelFunc: () => {
                            selectedRoleId = {
                              id: $form.roleId,
                              name: role[searchKeyByValue(role, 'id', $form.roleId)].name,
                            };
                          },
                        });
                      } else {
                        $form.roleId = ev.detail.id;
                        handleChange(customInputEvent(`roleId`, ev.detail.id));
                        isManagerSelect();
                      }
                    }}
                    on:clear={(ev) => {}}
                    optionIdentifier="id"
                    getOptionLabel={(option) => {
                      return option.name;
                    }}
                  />
                  {#if $errors.roleId != undefined}
                    <label
                      for=""
                      class="formError">{$errors.roleId}</label
                    >
                  {/if}
                </div>
              </div>

              <div class="col-md-12">
                <div
                  class="form-group mb-3 position-relative {$errors.units && $errors.units != ''
                    ? 'error'
                    : ''}"
                >
                  <label
                    for=""
                    class="form-label">Business Unit</label
                  >
                  <Select
                    bind:selectedValue={selectedUnitLabel}
                    items={units}
                    isMulti={false}
                    showIndicator={true}
                    isClearable={false}
                    containerClasses="form-control"
                    placeholder="Add Business Unit"
                    getSelectionLabel={(option) => {
                      return option.name;
                    }}
                    on:select={(ev) => {
                      selectedUnitLabel = ev.detail;
                      if (selectedUnitLabel) {
                        let arr = $form.units != undefined ? $form.units : [];
                        if (searchKeyByValue(arr, 'id', selectedUnitLabel.id) !== -1) {
                          showDialog({
                            message: 'Unit already selected',
                          });
                        } else {
                          arr.push({
                            ...selectedUnitLabel,
                            unitId: selectedUnitLabel.id,
                            active: 1,
                          });
                          $form.units = arr;
                          selectedUnits = $form.units;
                          handleChange(customInputEvent(`units`, $form.units));
                          getUnitUsers();
                          selectedUnitLabel = null;
                        }
                      } else {
                        showDialog({
                          message: 'Please select unit',
                        });
                      }
                      setTimeout(() => {
                        selectedUnitLabel = undefined;
                      }, 100);
                    }}
                    name="units"
                    optionIdentifier="id"
                    getOptionLabel={(option) => {
                      return option.name;
                    }}
                  />
                  <!-- <Select
					bind:selectedValue={selectedUnitId}
					items={units}
					isMulti={true}
					showIndicator={true}
					isClearable={false}
					containerClasses="form-control"
					placeholder={"Select: Business Unit"}
					getSelectionLabel={(option) => {
					  return option.name;
					}}
					on:select={(ev) => {
					  selectedUnits = [];
					  if (ev.detail !== null) {
						ev.detail.forEach((element) => {
						  if (id == 0 || element.accessStatus){
							selectedUnits.push({ unitId: element.id });
						  }
						});
						handleChange(customInputEvent(`units`, ev.detail));
					  }else{
						handleChange(customInputEvent(`units`, undefined));
					  }

					  getUnitUsers();

					}}
					name= "units"
					on:clear={(ev) => {
					  var index = selectedUnits.findIndex(
						(p) => p.unitId == ev.detail.id
					  );
					  selectedUnits.splice(index, 1);
					}}
					optionIdentifier={"id"}
					getOptionLabel={(option) => {
					  return option.name;
					}}
				  /> -->
                  {#if $errors.units}
                    <label
                      class="formError"
                      for="">{$errors.units}</label
                    >
                  {/if}
                </div>
              </div>
              {#if $form.units}
                <div class="col-md-12">
                  <div class="form-group mb-3">
                    <ul class="ul-list">
                      {#each $form.units as item, i}
                        <li class="form-group my-2 {item.accessStatus ? 'active' : 'inactive'} ">
                          <div class="d-flex align-items-center">
                            <div class="checkbox c-checkbox px-1 filters">
                              <label class="font-size-12">
                                <input
                                  type="checkbox"
                                  disabled={item.accessStatus == false}
                                  checked={item.active == 1}
                                  on:change={(ev) => {
                                    let oldUnits = $form.units;
                                    oldUnits[i].active = ev.target.checked ? 1 : 0;
                                    $form.units = oldUnits;
                                    if (id > 0 && oldUnits[i].active == 0) {
                                      checkTaskCount(item.id, 'checkbox');
                                    }
                                  }}
                                />
                                <span class="check-img"></span>
                                {item.name}</label
                              >
                            </div>
                            <button
                              on:click={() => {
                                checkTaskCount(item.id);
                              }}
                              disabled={item.accessStatus == false}
                              class="btn btn-link px-0 mb-0 shadow-none border-0 font-size-12 close-button bg-transparent d-flex align-items-center justify-content-center"
                            >
                              <img
                                alt=""
                                class="icon-16"
                                src="/images/close.svg"
                              />
                            </button>
                          </div>
                        </li>
                      {/each}
                    </ul>
                  </div>
                </div>

                {#if isManager}
                  <!-- <div class="col-md-12">
				  <div class="form-group mb-3  position-relative {($errors.users && $errors.users != "")?"error":""}">
					<label for="" class="form-label">Select Users</label>
					<Select
					  bind:selectedValue={selectedUsers}
					  placeholder={"Select: Users"}
					  isMulti={true}
					  items={unitUsers}
					  isClearable={false}
					  containerClasses="form-control"
					  getSelectionLabel={(option) => {
						return option.firstName + " " + option.lastName;
					  }}
					  on:select={(ev) => {
						if (ev.detail == null){
						  handleChange(customInputEvent(`users`, undefined));
						}else{
						  handleChange(customInputEvent(`users`, ev.detail));
						}
					  }}
					  on:clear={(ev) => {
					  }}
					  optionIdentifier={"userId"}
					  getOptionLabel={(option) => {
						return option.firstName + " " + option.lastName;
					  }}
					/>
					 {#if $errors.users}
					  <label class="formError">{$errors.users}</label>
					 {/if}
				  </div>
				</div> -->

                  <label
                    for=""
                    class="form-label font-size-16">Assign Users</label
                  >
                  {#each $form.units as unit, i}
                    <div class="col-md-12">
                      <div
                        class="form-group mb-3 position-relative {$errors.units &&
                        $errors.units != ''
                          ? 'error'
                          : ''}"
                      >
                        <label
                          for=""
                          class="form-label">{unit.name} Users</label
                        >
                        <Select
                          bind:selectedValue={selectedUnitUserLabel[unit.id]}
                          items={unitUsers.filter((item) => {
                            return searchKeyByValue(item.units, 'id', unit.id, 'active', 1) != -1;
                          })}
                          isDisabled={unit.accessStatus == false}
                          isMulti={false}
                          showIndicator={true}
                          isClearable={false}
                          containerClasses="form-control"
                          placeholder={'Add ' + unit.name + ' Users'}
                          getSelectionLabel={(option) => {
                            return option.firstName + ' ' + option.lastName;
                          }}
                          on:select={(ev) => {
                            ev.stopImmediatePropagation();
                            selectedUnitUserLabel[unit.id] = ev.detail;
                            if (selectedUnitUserLabel[unit.id]) {
                              let arr = ($form.users != undefined ? $form.users : []).filter(
                                (item) => {
                                  return item.unitId == unit.id;
                                },
                              );
                              if (
                                searchKeyByValue(
                                  arr,
                                  'userId',
                                  selectedUnitUserLabel[unit.id].userId,
                                ) !== -1
                              ) {
                                showDialog({
                                  message: 'User already selected',
                                });
                              } else {
                                arr = $form.users != undefined ? $form.users : [];
                                arr.push({
                                  ...selectedUnitUserLabel[unit.id],
                                  unitId: unit.id,
                                });
                                $form.users = arr;
                                selectedUsers = $form.users;
                                handleChange(customInputEvent(`users`, $form.users));
                                selectedUnitUserLabel[unit.id] = null;
                              }
                            } else {
                              showDialog({
                                message: 'Please select user',
                              });
                            }
                            setTimeout(() => {
                              selectedUnitUserLabel[unit.id] = undefined;
                            }, 100);
                          }}
                          name="users[{unit.id}]"
                          optionIdentifier="id"
                          getOptionLabel={(option) => {
                            return option.firstName + ' ' + option.lastName;
                          }}
                        />
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group mb-3">
                        <ul class="ul-list">
                          {#each ($form.users != undefined ? $form.users : []).filter((item) => {
                            return item.unitId == unit.id;
                          }) as item}
                            <li
                              class="form-group my-2 {unit.accessStatus == false
                                ? 'inactive'
                                : 'active'} "
                            >
                              <div class="d-flex align-items-center">
                                <label
                                  for=""
                                  class="mb-0 form-label"
                                  >{item.firstName + ' ' + item.lastName}</label
                                >
                                <button
                                  on:click={() => {
                                    let oldUsers = $form.users;
                                    let foundKey = -1;
                                    for (var i in oldUsers) {
                                      if (
                                        oldUsers[i].unitId == unit.id &&
                                        oldUsers[i].userId == item.userId
                                      ) {
                                        foundKey = i;
                                        break;
                                      }
                                    }
                                    if (foundKey != -1) {
                                      oldUsers.splice(foundKey, 1);
                                      $form.users = oldUsers;
                                      selectedUsers = $form.users;
                                    }
                                  }}
                                  disabled={unit.accessStatus == false}
                                  class="btn btn-link px-0 mb-0 shadow-none border-0 font-size-12 close-button bg-transparent d-flex align-items-center justify-content-center"
                                >
                                  <img
                                    alt=""
                                    class="icon-16"
                                    src="/images/close.svg"
                                  />
                                </button>
                              </div>
                            </li>
                          {/each}
                        </ul>
                      </div>
                    </div>
                  {/each}
                {/if}

                <label
                  for=""
                  class="form-label font-size-16">Assign Clients</label
                >
                {#each $form.units as unit, i}
                  <div class="col-md-12">
                    <div
                      class="form-group mb-3 position-relative {$errors.units && $errors.units != ''
                        ? 'error'
                        : ''}"
                    >
                      <label
                        for=""
                        class="form-label">{unit.name} Clients</label
                      >
                      <Select
                        isDisabled={unit.accessStatus == false}
                        bind:selectedValue={selectedUnitClient[unit.id]}
                        items={unitClients.filter((item) => {
                          return item.unitId == unit.id;
                        })}
                        isMulti={true}
                        showIndicator={true}
                        isClearable={false}
                        containerClasses="form-control"
                        placeholder={'Add ' + unit.name + ' Clients'}
                        getSelectionLabel={(option) => {
                          return option.name;
                        }}
                        on:select={(ev) => {
                          if (ev.detail != null) {
                            selectedUnitClient[unit.id] = ev.detail;
                          } else {
                            delete selectedUnitClient[unit.id];
                          }
                        }}
                        name="clients[{unit.id}]"
                        optionIdentifier="id"
                        getOptionLabel={(option) => {
                          return option.name;
                        }}
                      />
                    </div>
                  </div>
                {/each}
              {/if}
            </div>

            <!-- <div class="row">
			  <div class="col-md-6">
				<div class="form-group mb-3">
				  <FormInput
					disabled={disablePassword}
					label="Password "
					type="password"
					placeholder="Enter Password"
					{handleChange}
					name="password"
					error={$errors.password}
					bind:value={$form.password}
				  />
				</div>
			  </div>
			  <div class="col-md-6">
				<FormInput
				  disabled={disablePassword}
				  label="Confirm Password "
				  type="password"
				  placeholder="Enter Confirm Password"
				  {handleChange}
				  name="confirmPassword"
				  error={$errors.confirmPassword}
				  bind:value={$form.confirmPassword}
				/>
			  </div>
			</div> -->
            <div class="row">
              <div class="col-md-6">
                <label
                  for=""
                  class="form-label">Mobile No.</label
                >
                <!-- </div> -->

                {#each $form.mobileNos as item, i}
                  <!-- {#if item.deleted == undefined} -->
                  <!-- <div class="col-md-6"> -->
                  <div class="d-flex flex-row align-items-center">
                    <div class="w-100">
                      <FormInput
                        placeholder="Enter Mobile"
                        handleChange={handleChange}
                        name={`mobileNos[${i}].mobile`}
                        error={$errors.mobileNos[i] != undefined &&
                        $errors.mobileNos[i].mobile != undefined
                          ? $errors.mobileNos[i].mobile
                          : ''}
                        bind:value={$form.mobileNos[i].mobile}
                      />
                    </div>
                    <div class="mb-3">
                      <button
                        class="bg-transparent border-0 ms-2"
                        on:click={() => {
                          if (i == 0) {
                            const mobileN = $form.mobileNos[$form.mobileNos.length - 1].mobile;
                            if (mobileN != '') {
                              addMobile();
                            } else {
                              showDialog({
                                message: 'Please Enter Mobile Number',
                              });
                            }
                          } else {
                            removeMobile(i);
                          }
                        }}
                      >
                        <img
                          class="icon-size"
                          alt=""
                          src={i == 0 ? '/images/plus.svg' : '/images/cancel.svg'}
                        />
                      </button>
                    </div>
                  </div>
                  <!-- </div> -->
                  <!-- {/if} -->
                {/each}
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div
                  class="form-group mb-3 select-block position-relative select-date-formats {$errors.dateFormatId
                    ? 'error'
                    : ''}"
                >
                  <label
                    for=""
                    class="form-label">Date Format</label
                  >
                  <Select
                    class="form-control"
                    bind:selectedValue={selectedDateFormatId}
                    items={dateFormates}
                    showChevron={true}
                    isClearable={true}
                    containerClasses="form-control"
                    placeholder="Select: Date Format"
                    on:select={(ev) => {
                      $form.dateFormatId = ev.detail.id;
                      handleChange(customInputEvent(`dateFormatId`, ev.detail.id));
                    }}
                    on:clear={(ev) => {}}
                    optionIdentifier="id"
                    getSelectionLabel={(option) => {
                      return option.name;
                    }}
                    getOptionLabel={(option) => {
                      return option.name;
                    }}
                  />
                  {#if $errors.dateFormatId}
                    <label
                      for=""
                      class="formError">{$errors.dateFormatId}</label
                    >
                  {/if}
                </div>
              </div>

              <div class="col-md-6">
                <div
                  class="form-group mb-3 select-block position-relative {$errors.timeZoneId
                    ? 'error'
                    : ''}"
                >
                  <label
                    for=""
                    class="form-label">Time Zone</label
                  >
                  <Select
                    class="form-control"
                    bind:selectedValue={selectedTimeZoneId}
                    items={timeZones}
                    showChevron={true}
                    isClearable={true}
                    containerClasses="form-control"
                    placeholder="Select: Time Zone"
                    name="timeZoneId"
                    on:select={(ev) => {
                      $form.timeZoneId = ev.detail.id;
                      handleChange(customInputEvent(`timeZoneId`, ev.detail.id));
                    }}
                    on:clear={(ev) => {}}
                    optionIdentifier="id"
                    getSelectionLabel={(option) => {
                      return option.name;
                    }}
                    getOptionLabel={(option) => {
                      return option.name;
                    }}
                  />
                  {#if $errors.timeZoneId}
                    <label
                      for=""
                      class="formError">{$errors.timeZoneId}</label
                    >
                  {/if}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group select-block mb-3">
                  <label
                    for="countryId"
                    class="form-label"
                    >Country
                  </label>
                  <Select
                    bind:selectedValue={$form.countryLabel}
                    showChevron={true}
                    isClearable={false}
                    items={countries}
                    getSelectionLabel={(option) => {
                      return option.name;
                    }}
                    on:select={(ev) => {
                      $form.countryId = ev.detail.id;
                    }}
                    optionIdentifier="id"
                    getOptionLabel={(option) => {
                      return option.name;
                    }}
                    placeholder="Country"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group select-block mb-3">
                  {#if $form.countryId == stateCountryId}
                    <label
                      for="countryId"
                      class="form-label"
                      >State / Province
                    </label>
                    <Select
                      bind:this={objState}
                      bind:selectedValue={$form.stateLabel}
                      showChevron={true}
                      isClearable={false}
                      items={states}
                      getSelectionLabel={(option) => {
                        return option.name;
                      }}
                      on:select={(ev) => {
                        $form.stateId = ev.detail.id;
                      }}
                      optionIdentifier="id"
                      getOptionLabel={(option) => {
                        return option.name;
                      }}
                      placeholder="State / Province"
                    />
                  {:else}
                    <FormInput
                      name="state"
                      label="State / Province"
                      placeholder="State / Province"
                      error={$errors.state}
                      bind:value={$form.state}
                      handleChange={handleChange}
                    />
                  {/if}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <!-- <FormInput
				  label="Slack User Name "
				  type="text"
				  placeholder="Enter Slack User Name"
				  {handleChange}
				  name="slackUsername"
				  error={$errors.slackUsername}
				  bind:value={$form.slackUsername}
				/> -->
                <FormInput
                  label="MS Teams User Name "
                  type="text"
                  placeholder="Enter MS Teams User Name"
                  handleChange={handleChange}
                  name="msTeamUsername"
                  error={$errors.msTeamUsername}
                  bind:value={$form.msTeamUsername}
                />
              </div>
              <div class="col-md-6">
                <div
                  class="form-group mb-3 select-block position-relative {$errors.associatedRegionId
                    ? 'error'
                    : ''}"
                >
                  <label
                    for=""
                    class="form-label">Associated Region</label
                  >
                  <Select
                    bind:selectedValue={$form.associatedRegionLabel}
                    showChevron={true}
                    isClearable={false}
                    items={associatedRegions}
                    containerClasses="form-control"
                    getSelectionLabel={(option) => {
                      return option.name;
                    }}
                    on:select={(ev) => {
                      $form.associatedRegionId = ev.detail.id;
                      handleChange(customInputEvent('associatedRegionId', ev.detail.id));
                    }}
                    optionIdentifier="id"
                    getOptionLabel={(option) => {
                      return option.name;
                    }}
                    placeholder="Associated Region"
                  />
                  {#if $errors.associatedRegionId}
                    <label
                      for=""
                      class="formError">{$errors.associatedRegionId}</label
                    >
                  {/if}
                </div>
              </div>
              <div class="col-md-6">
                <div
                  class="form-group mb-3 position-relative {$errors.deliveryVerticalIds &&
                  $errors.deliveryVerticalIds != ''
                    ? 'error'
                    : ''}"
                >
                  <label
                    for=""
                    class="form-label">Delivery Verticals</label
                  >
                  <div class="form-group select-block select-client-type engagement-dropdown">
                    <DropDown
                      checkbox={true}
                      active={true}
                      searchbox={true}
                      title="Select Delivery Verticals"
                      labelFields="name"
                      keyFields="id"
                      option={deliveryVerticals.filter((item) => {
                        return true;
                      })}
                      checkedFields="checked"
                      Style="select-block  font-size-13 w-100"
                      on:onSelect={(event) => {
                        addDeliveryVerticalType();
                        // handleChange()
                      }}
                    />
                  </div>
                  {#if $errors.deliveryVerticalIds}
                    <label
                      for=""
                      class="formError"
                      style="right: 165px;bottom: -19px;">{$errors.deliveryVerticalIds}</label
                    >
                  {/if}
                </div>

                {#each $form.deliveryVerticalLabel as item, i}
                  <div
                    class="d-flex flex-row align-items-center justify-content-between mb-1 list-items-block"
                  >
                    <div class=" px-1">{item.name}</div>
                    <div class="d-flex flex-row align-items-center">
                      <div class="me-1">
                        <button
                          on:click={() => removeType(i, 'deliveryVertical')}
                          class="btn btn-link bg-transparent border-0 shadow-none pe-0"
                        >
                          <img
                            class="icon-16"
                            alt=""
                            src="/images/remove.svg"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                {/each}
              </div>

              <div class="col-md-6">
                <div
                  class="form-group mb-2 position-relative {$errors.legacyCompanyType
                    ? 'error'
                    : ''}"
                >
                  <label
                    for=""
                    class="form-label">Legacy Company:</label
                  >
                  {#each legacyCompanyTypeLabel as legacyCompany}
                    <div class="position-relative mb-1">
                      <div class="row align-items-center justify-content-start">
                        <div class="form-label mb-0 position-relative">
                          <div class="radio c-radio {$errors.legacyCompanyType ? 'error' : ''}">
                            <label class="text-nowrap">
                              <input
                                type="radio"
                                name="legacyCompany"
                                value={legacyCompany.id}
                                bind:group={$form.legacyCompanyType}
                                on:change={(event) => {
                                  $form.legacyCompanyType = legacyCompany.id;
                                  // resetRecurringData();
                                  handleChange(
                                    customInputEvent('legacyCompanyType', $form.legacyCompanyType),
                                  );
                                }}
                              />
                              <span class="check-img" />
                              {legacyCompany.name}
                            </label>
                            {#if legacyCompany.id == $form.legacyCompanyType}
                              <button
                                on:click={(event) => {
                                  $form.legacyCompanyType = '';
                                }}
                                class="btn btn-link position-absolute"
                                style="top: -1px;padding: 0px;"
                                ><span
                                  class="color-white font-size-12 font-weight-400"
                                  style="
								width: 70px;
								border: 0;
							">De-select</span
                                ></button
                              >
                            {/if}
                          </div>
                        </div>
                      </div>
                    </div>
                  {/each}
                  {#if $errors.legacyCompanyType}
                    <label
                      for=""
                      class="formError">{$errors.legacyCompanyType}</label
                    >
                  {/if}
                </div>
              </div>
              {#if $form.id > 0 && $form.resentActivationEmail == 1}
                <div class="col-md-6">
                  <div
                    class="checkbox c-checkbox"
                    style="margin-top:33px;"
                  >
                    <label>
                      <input
                        type="checkbox"
                        on:change={(event) =>
                          ($form.resentActivationEmail = event.target.checked ? 1 : 0)}
                      />
                      <span class="check-img" />
                      Resend activation link
                    </label>
                  </div>
                </div>
              {/if}
            </div>
          </div>
        </div>
      </div>
      <div class=" d-flex align-items-center justify-content-end p-3">
        <button
          class="trans-btn mb-0 px-3 font-size-12 outline-0 btn-cancel me-2"
          on:click={onCancel}
        >
          Cancel</button
        >
        <button
          class="btn btn-primary background-blue mb-0 font-size-12 text-white add-task"
          disabled={isFormPending}
          on:click={handleSubmit}
          >{#if isFormPending}
            <Loader />
          {:else}
            {#if id != 0}
              Update User
            {:else}Create User{/if}{/if}</button
        >
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  .deactive-user {
    background-color: $light-blue-color;
    padding: 6px;
    width: 210px;
    margin-top: 33px;
  }

  .user-profile-img-block {
    width: 165px;
    flex: 0 0 165px;
  }
</style>
